import { useState } from 'react';
import '../styles/ResetPassword.css';
import { FaLock, FaExclamationCircle, FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import CommonButton from '../components/CommonButton';
import CustomFormGroup from '../components/CustomFormGroup';
import MessageModal from '../components/MessageModal';
import { resetPassword } from '../services/api/authService';
import { useNavigate } from "react-router-dom";
import { useEffect } from 'react';
import { supabase } from '../services/supabase/supabaseClient';

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '' });
  const [error, setError] = useState('');
  const [touched, setTouched] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleTogglePassword = () => {
    setShowPassword(prev => !prev);
  };

  const validate = () => {
    const errors = {};
    if (!form.password) errors.password = 'Password is required';
    return errors;
  };

  const errors = validate();
  const isValid = Object.keys(errors).length === 0;

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');

    if (!isValid) {
      setTouched({ password: true });
      return;
    }

    const result = await resetPassword(form.password);

    if (result.success) {
      await supabase.auth.signOut();
      setIsModalOpen(true);
    } else {
      setError(result.message);
    }
  };

  const handleGoToLogin = async () => {
    setIsModalOpen(false);
    await supabase.auth.signOut();
    window.location.href = '/';
  };

  return (
    <div className="reset-password-page">
      <div className="reset-password-container">
        <h2 className="reset-password-title">Reset Password</h2>

        <form onSubmit={handleResetPassword} noValidate>
          <CustomFormGroup
            type={showPassword ? 'text' : 'password'}
            name="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Password"
            icon={<FaLock />}
            togglePassword
            showPassword={showPassword}
            onTogglePassword={handleTogglePassword}
            error={touched.password && errors.password}
          />

          {error && (
            <div className="reset-password-error">
              <FaExclamationCircle /> {error}
            </div>
          )}

          <CommonButton type="submit">Update Password</CommonButton>
        </form>
      </div>

      {isModalOpen && (
        <MessageModal 
          onClose={handleGoToLogin}
          title={'Password Reset Successfully!'}
          message_content={
            error === '' 
              ? (
                  <>
                    Your password has been updated. Please log in again.<br/>
                  </>
                )
              : error
          }
          icon={error === '' ? <FaCheckCircle/> : <FaTimesCircle/>}
          button_name={'Go To Login Page'}
          isSuccess={error === ''}
        />
      )}
    </div>
  );
};

export default ResetPasswordPage;
